import { render, staticRenderFns } from "./BsSelectMultiple.vue?vue&type=template&id=40a8852a&scoped=true&"
import script from "./BsSelectMultiple.vue?vue&type=script&lang=js&"
export * from "./BsSelectMultiple.vue?vue&type=script&lang=js&"
import style0 from "./BsSelectMultiple.vue?vue&type=style&index=0&id=40a8852a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a8852a",
  null
  
)

export default component.exports